import { createFileRoute } from "@tanstack/react-router";
import AdminProposals from "@/pages/admin/AdminProposals";

export const Route = createFileRoute("/admin/presupuestos")({ component: AdminProposals });
